import React from 'react'
import { StyledSectionSubtitle } from './styles'

const DrawerSectionSubtitle = ({ subtitle }) => {
  return <StyledSectionSubtitle>{subtitle}</StyledSectionSubtitle>
}

export { DrawerSectionSubtitle }
